// extracted by mini-css-extract-plugin
export default {"nameCell":"nameCell---iCusn"};